import { globalError, TYPE_ERROR } from 'app/shared/error/error-global';
import { gtmApi } from '../api';
import { ACTION_TYPES } from './store/gtm.action';

export const initializeGtm = gtmContainerId => async dispatch => {
  await gtmApi.initGtm(gtmContainerId);

  await dispatch({
    type: ACTION_TYPES.INITIALIZE_GTM
  });
};

export const updateContainerId = () => async dispatch => {
  const result = await gtmApi.updateContainerId();

  if (result.isFailure) {
    globalError.next({ type: TYPE_ERROR.GLOBAL, error: result.errorValue() });
    return;
  }

  const gtmContainerId = result.getValue();

  await dispatch({
    type: ACTION_TYPES.UPDATE_CONTAINER_ID,
    payload: gtmContainerId
  });

  if (gtmContainerId && gtmContainerId !== '') {
    await dispatch(initializeGtm(gtmContainerId));
  }
};

export const gtmEvent = (eventCategory: string, eventAction: string, eventValue: string) => async (dispatch, getState) => {
  const { containerId } = await getState().gtm;
  const { subscriptionNumber } = await getState().subscription;

  if (containerId) await gtmApi.gtmEvent(containerId, eventCategory, eventAction, subscriptionNumber, eventValue);
};
